import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SaintLuciaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15391'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15391)'>
				<rect
					width='20'
					height='14'
					fill='#86D7FF'
				/>
				<g filter='url(#filter0_d_2332_15391)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0006 1.8667L14.2863 12.1334H5.71484L10.0006 1.8667Z'
						fill='white'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 3.73328L13.3327 12.1333H6.66602L9.99935 3.73328Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 6.53333L14.2863 12.1333H5.71484L10.0006 6.53333Z'
					fill='#FFDA57'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15391'
					x='5.71484'
					y='1.8667'
					width='8.57227'
					height='11.2667'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15391'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15391'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default SaintLuciaFlagIcon;
